// KAN-114: portal notification centre (bell in the header).
import { ApiClient } from './apiClient';

export interface PortalNotification {
  id: number;
  type: string;
  title: string;
  body: string | null;
  link: string | null;
  createdAt: string;
  readAt: string | null;
}

export interface NotificationList {
  unread: number;
  notifications: PortalNotification[];
}

export const getNotifications = (limit = 20): Promise<NotificationList> =>
  ApiClient.get<NotificationList>(`/admin/notifications?limit=${limit}`);

export const markNotificationRead = (id: number): Promise<{ ok: boolean }> =>
  ApiClient.post<{ ok: boolean }>(`/admin/notifications/${id}/read`, {});

export const markAllNotificationsRead = (): Promise<{ ok: boolean; marked: number }> =>
  ApiClient.post<{ ok: boolean; marked: number }>('/admin/notifications/read-all', {});
